module.exports = __webpack_public_path__ + "img/Futtern.80732631.jpg";